import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { apiRootSelector } from '@schir-int-client/api-root';
import { changeFileAction, changeFileSuccessAction, FileType } from '@schir-int-client/binary-shared';
import { doNothingAction } from '@schir-int-client/ngrx-helpers';
import { isEqual } from 'lodash-es';
import { of } from 'rxjs';
import { map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import {
	deleteVorlageAction,
	loadVorlageAction,
	loadVorlagenAction,
	loadVorlagenSuccessAction,
	loadVorlageSuccessAction,
	saveVorlageAction,
} from './vorlage.actions';
import { VorlageLinkRel } from './vorlage.linkrel';
import { VorlageService } from './vorlage.service';
import { AppState } from '../../../../apps/int-client/src/app/shared/store/app-state.model';

@Injectable()
export class VorlageEffects {
	constructor(
		private actions: Actions,
		private vorlageService: VorlageService,
		private store: Store<AppState>
	) {}

	loadVorlagen = createEffect(() =>
		this.actions.pipe(
			ofType(loadVorlagenAction),
			withLatestFrom(this.store.select(apiRootSelector)),
			switchMap(([, apiRoot]) => {
				return this.vorlageService
					.getAll(apiRoot)
					.pipe(map(vorlagen => loadVorlagenSuccessAction({ vorlagen })));
			})
		)
	);

	saveVorlage = createEffect(() =>
		this.actions.pipe(
			ofType(saveVorlageAction),
			withLatestFrom(this.store.select(apiRootSelector)),
			switchMap(([{ createVorlage }, apiRoot]) => {
				return this.vorlageService.saveOne(apiRoot, createVorlage).pipe(
					map(vorlage =>
						changeFileAction({
							resource: vorlage,
							linkRel: VorlageLinkRel.UPLOAD_FILE,
							fileType: FileType.VORLAGE,
							file: createVorlage.file,
						})
					)
				);
			})
		)
	);

	deleteVorlage = createEffect(() =>
		this.actions.pipe(
			ofType(deleteVorlageAction),
			switchMap(({ vorlage }) => {
				return this.vorlageService.deleteOne(vorlage).pipe(map(loadVorlagenAction));
			})
		)
	);

	loadVorlageInAufgabe = createEffect(() =>
		this.actions.pipe(
			ofType(loadVorlageAction),
			mergeMap(({ aufgabe }) => {
				return this.vorlageService
					.getByAufgabe(aufgabe)
					.pipe(map(vorlage => loadVorlageSuccessAction({ vorlage })));
			})
		)
	);

	changeFileSuccess = createEffect(() =>
		this.actions.pipe(
			ofType(changeFileSuccessAction),
			switchMap(({ fileType }) => {
				return isEqual(fileType, FileType.VORLAGE) ? of(loadVorlagenAction()) : of(doNothingAction());
			})
		)
	);
}
